// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TEGgP","col":"styles_col__14kv4"};